import { Record } from 'immutable';

export default class QuestionnaireRecord extends Record({
  id: undefined,
  name: undefined,
  createdAt: undefined,
  updatedAt: undefined,
}) {
}
